import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Wind
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuNyA3LjdhMi41IDIuNSAwIDEgMSAxLjggNC4zSDIiIC8+CiAgPHBhdGggZD0iTTkuNiA0LjZBMiAyIDAgMSAxIDExIDhIMiIgLz4KICA8cGF0aCBkPSJNMTIuNiAxOS40QTIgMiAwIDEgMCAxNCAxNkgyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/wind
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const Wind = createLucideIcon('WindIcon', [
  ['path', { d: 'M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2', key: '1k4u03' }],
  ['path', { d: 'M9.6 4.6A2 2 0 1 1 11 8H2', key: 'b7d0fd' }],
  ['path', { d: 'M12.6 19.4A2 2 0 1 0 14 16H2', key: '1p5cb3' }],
]);

export default Wind;
